import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Check } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 bg-stone-50" data-id="element-95">
      <div className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-6 md:p-10 rounded-2xl md:rounded-3xl shadow-xl text-center" data-id="element-97">
          <div className="bg-gradient-to-br from-amber-100 to-yellow-100 w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6" data-id="element-98">
            <Shield className="w-8 h-8 md:w-10 md:h-10 text-amber-600" data-id="element-99" />
          </div>

          <h2 className="font-serif text-2xl md:text-4xl font-bold text-stone-900 mb-4 md:mb-6" data-id="element-100">
            Garantia de Satisfação Total
          </h2>

          <p className="text-lg md:text-xl text-stone-700 mb-6 md:mb-8 leading-relaxed" data-id="element-101">
            Se você não achar{' '}
            <span className="font-bold text-amber-600" data-id="element-102">
              pelo menos 5 ideias lindas
            </span>{' '}
            e possíveis de fazer, devolvo{' '}
            <span className="font-bold" data-id="element-103">100% do valor</span>.
          </p>

          <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-5 md:p-7 rounded-xl md:rounded-2xl mb-6 md:mb-8" data-id="element-104">
            <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-4 md:mb-5" data-id="element-105">
              Por que essa garantia existe?
            </h3>

            <div className="space-y-3 md:space-y-4 text-left" data-id="element-106">
              <div className="flex items-start gap-3" data-id="element-107">
                <Check className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-108" />
                <p className="text-sm md:text-base text-stone-700" data-id="element-109">
                  Porque eu sei que o guia funciona. Dezenas de noivas já usaram
                  e aprovaram.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-110">
                <Check className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-111" />
                <p className="text-sm md:text-base text-stone-700" data-id="element-112">
                  Porque são 40 ideias diferentes. É matematicamente impossível
                  você não gostar de pelo menos 5.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-113">
                <Check className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-114" />
                <p className="text-sm md:text-base text-stone-700" data-id="element-115">
                  Porque eu quero que você se sinta 100% segura e confiante na
                  sua decisão.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-amber-100 border-l-4 border-amber-500 p-4 md:p-5 rounded-lg" data-id="element-116">
            <p className="text-base md:text-lg text-stone-800 leading-relaxed" data-id="element-117">
              <span className="font-bold" data-id="element-118">Você não tem nada a perder.</span>{' '}
              Apenas economia, elegância e tranquilidade para ganhar.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}